import React, { useContext, useEffect, useState } from "react";

import Slider from "react-slick";

import { SliderContainer } from "./styles.js";
import { ContextSolicitacoes } from "../../../../services/solicitacoes";

import useWindowDimension from "../../../../hooks/WindowDimension";

import RepairCard from "./card";
import { ContextSindico } from "../../../../services/sindico.js";

import MessagePopUp from "../../../MessagePopup/index.js";

import { ButtonPrimary } from "../../../StyledComponent.js";

const ResumoAgendamento = ({
  reparos,
  tema,
  anexos,
  acompanharSolicitacao,
  editarSolicitacao,
  novaSolicitacao,
  setReparos,
  setSalvarAlteracoes,
  confirmarSolicitacao,
  savingChanges,
  isSindico,
}) => {
  const [showSucessEditPopup, setShowSucessEditPopup] = useState(false);
  const [showSucessRemoveReparoPopup, setShowSucessRemoveReparoPopup] =
    useState(false);

  const dimensions = useWindowDimension();

  const { apontamentos, setApontamentos, dynamicSort, setRemovedDocuments } =
    useContext(isSindico ? ContextSindico : ContextSolicitacoes);

  const carrosselSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: dimensions.winWidth <= 768 ? 1 : 2,
    slidesToScroll: dimensions.winWidth <= 768 ? 1 : 2,
    centerPadding: "60px",
  };

  const sortByAlphabeticalOrder = (a, b) => {
    let valueA = a?.descricao || a?.Descricao || a?.apontamento;
    let valueB = b?.descricao || b?.Descricao || b?.apontamento;
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  };
  const disableRemove =
    (!novaSolicitacao && reparos?.length < 2) || savingChanges;

  const handleRemoveReparo = (
    idApontamentoParaRemover,
    irregularidade,
    documentosAnexados
  ) => {
    setApontamentos(
      [...apontamentos, { nome: irregularidade }].sort(dynamicSort("nome"))
    );
    let temp = reparos.filter(
      (apontamento) => apontamento.idSelecaoReparo != idApontamentoParaRemover
    );

    setRemovedDocuments(documentosAnexados);

    setReparos(temp);

    if (!novaSolicitacao) setSalvarAlteracoes(true);
  };

  useEffect(() => {
    if (anexos?.length > 0) {
      let newReparos = [];

      reparos.map((reparo) => {
        let documentos = anexos.filter(
          (anexo) => reparo.workTypeId === anexo.descricao
        );

        reparo = { ...reparo, documents: documentos[0]?.documentosS3 };

        newReparos.push(reparo);
      });

      setReparos(newReparos);
    }
  }, []);

  return (
    <>
      {reparos.length > 0 && (
        <SliderContainer colorTheme={tema?.primaryColor}>
          <Slider {...carrosselSettings}>
            {reparos.sort(sortByAlphabeticalOrder).map((reparo, index) => {
              return (
                <RepairCard
                  reparos={reparos}
                  reparo={reparo}
                  index={index}
                  tema={tema}
                  editarSolicitacao={editarSolicitacao}
                  acompanharSolicitacao={acompanharSolicitacao}
                  novaSolicitacao={novaSolicitacao}
                  disableRemove={disableRemove}
                  handleRemoveReparo={handleRemoveReparo}
                  key={index}
                  setReparos={setReparos}
                  confirmarSolicitacao={confirmarSolicitacao}
                  setSalvarAlteracoes={setSalvarAlteracoes}
                  savingChanges={savingChanges}
                  isSindico={isSindico}
                  setShowSucessEditPopup={setShowSucessEditPopup}
                  setShowSucessRemoveReparoPopup={
                    setShowSucessRemoveReparoPopup
                  }
                />
              );
              // );
            })}
          </Slider>
        </SliderContainer>
      )}

      {showSucessEditPopup && (
        <MessagePopUp
          title={"Edição feita com sucesso!"}
          message={"A correção no reparo foi realizada"}
        >
          <ButtonPrimary
            fullWidth
            tema={tema}
            onClick={() => setShowSucessEditPopup(false)}
          >
            Confirmar
          </ButtonPrimary>
        </MessagePopUp>
      )}

      {showSucessRemoveReparoPopup && (
        <MessagePopUp
          title={"Remoção feita com sucesso!"}
          message={"A remoção do reparo foi realizada"}
        >
          <ButtonPrimary
            fullWidth
            tema={tema}
            onClick={() => setShowSucessRemoveReparoPopup(false)}
          >
            Confirmar
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </>
  );
};

export default ResumoAgendamento;
